export class Information {
  A: string;
  B: string;
  C: string;
  D: string;
  E: string;
  F: string;
}
